import { render, staticRenderFns } from "./BidderOfferView.vue?vue&type=template&id=4d1cdd3f&scoped=true&"
import script from "./BidderOfferView.vue?vue&type=script&lang=js&"
export * from "./BidderOfferView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1cdd3f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib'
installComponents(component, {VCardTitle})
